// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Anta&family=Chelsea+Market&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cPR75kdAXDGVxib0PszB {
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 3vmin;
}
.cPR75kdAXDGVxib0PszB .ap70fWT3eETsAtLlRQKl {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 3rem;
  font-family: "Chelsea Market", sans-serif;
  font-size: 1.5rem;
  color: yellow;
  text-shadow: 2px 2px 1px black;
}
.cPR75kdAXDGVxib0PszB .ap70fWT3eETsAtLlRQKl .b73kZ_AIC8CmOngOZegg {
  margin-left: 1rem;
}
.cPR75kdAXDGVxib0PszB .w_xrohFcLzqrK66BLoMH {
  margin-top: 3vmin;
  padding-top: 2rem;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  background-color: rgb(64, 64, 64);
  color: white;
  text-shadow: 2px 2px 1px black;
  font-size: 1.5rem;
  border-radius: 10px;
  gap: 3rem;
  justify-content: flex-start;
  height: calc(100vh - 18vmin);
  width: 75vw;
  max-width: 40rem;
}
.cPR75kdAXDGVxib0PszB .w_xrohFcLzqrK66BLoMH .V5OAbv7QFHo6WglNx0m0 {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  padding: 1vmin 0;
  color: white;
  text-shadow: 2px 2px 1px black;
  border: 0.1vmin solid var(--tan-3);
}
.cPR75kdAXDGVxib0PszB .w_xrohFcLzqrK66BLoMH .V5OAbv7QFHo6WglNx0m0 .zypoFNoBI8rmWRRI9Gn4 {
  background-color: red;
  text-shadow: 2px 2px 1px black;
  cursor: pointer;
  width: 15vw;
  text-align: center;
  height: 3rem;
  min-width: 6rem;
  border: 2px solid white;
  font-size: clamp(15px, 2vw, 25px);
}
.cPR75kdAXDGVxib0PszB .w_xrohFcLzqrK66BLoMH .V5OAbv7QFHo6WglNx0m0 .h9JmrZXsbkyHUL5udmun {
  font-size: 1.25rem;
}
.cPR75kdAXDGVxib0PszB .w_xrohFcLzqrK66BLoMH .V5OAbv7QFHo6WglNx0m0 .qNtiRvndMCsLxZjeMJKO {
  font-size: 1.25rem;
}
.cPR75kdAXDGVxib0PszB .w_xrohFcLzqrK66BLoMH .V5OAbv7QFHo6WglNx0m0 .p73ZrVK0TdkEr6st7NOK {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5vw;
  color: var(--text-dark);
}
.cPR75kdAXDGVxib0PszB .w_xrohFcLzqrK66BLoMH .V5OAbv7QFHo6WglNx0m0 .p73ZrVK0TdkEr6st7NOK .GtULiQQdndLNSQN4Yc97 {
  display: flex;
  justify-content: flex-end;
}
.cPR75kdAXDGVxib0PszB .w_xrohFcLzqrK66BLoMH .NAoveQ0xvm5VtSgh6clR {
  position: absolute;
  top: 50vh;
  font-family: "Chelsea Market", sans-serif;
  font-size: 4vmin;
  color: yellow;
  text-shadow: 2px 2px 1px black;
}`, "",{"version":3,"sources":["webpack://./src/components/OrderDetail/OrderDetail.module.scss"],"names":[],"mappings":"AAEA;EACI,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AAAJ;AAEI;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,yCAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;AAAN;AACM;EACE,iBAAA;AACR;AAGI;EACE,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,iCAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;EACA,4BAAA;EACA,WAAA;EACA,gBAAA;AADN;AAGM;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EAEA,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,kCAAA;AAFR;AAIQ;EACE,qBAAA;EACA,8BAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;EACA,iCAAA;AAFV;AAKQ;EACE,kBAAA;AAHV;AAMQ;EACE,kBAAA;AAJV;AAOQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AALV;AAOU;EACE,aAAA;EACA,yBAAA;AALZ;AAUM;EACE,kBAAA;EACA,SAAA;EACA,yCAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;AARR","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Anta&family=Chelsea+Market&display=swap');\n\n.OrderDetail {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    padding: 3vmin;\n\n    .sectionHeading {\n      display: flex;\n      justify-content: center;\n      width: 100%;\n      margin-bottom: 3rem;\n      font-family: \"Chelsea Market\", sans-serif;\n      font-size: 1.5rem;\n      color: yellow;\n      text-shadow: 2px 2px 1px black;\n      .orderDate {\n        margin-left: 1rem;\n      }\n    }\n\n    .lineGameContainer {\n      margin-top: 3vmin;\n      padding-top: 2rem;\n      margin-left: auto;\n      margin-right: auto;\n      display: flex;\n      flex-direction: column;\n      background-color: rgb(64, 64, 64);\n      color: white;\n      text-shadow: 2px 2px 1px black;\n      font-size: 1.5rem;\n      border-radius: 10px;\n      gap: 3rem;\n      justify-content: flex-start;\n      height: calc(100vh - 18vmin);\n      width: 75vw;\n      max-width: 40rem;\n      \n      .total {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 2rem;\n        \n        padding: 1vmin 0;\n        color: white;\n        text-shadow: 2px 2px 1px black;\n        border: .1vmin solid var(--tan-3);\n     \n        .button {\n          background-color: red;\n          text-shadow: 2px 2px 1px black;\n          cursor: pointer;\n          width: 15vw;\n          text-align: center;\n          height: 3rem;\n          min-width: 6rem;\n          border: 2px solid white;\n          font-size: clamp(15px, 2vw, 25px)\n        }\n        \n        .totalQty {\n          font-size: 1.25rem;\n        }\n\n        .totalPrice {\n          font-size: 1.25rem;\n        }\n\n        .span {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          font-size: 1.5vw;\n          color: var(--text-dark);\n\n          .right {\n            display: flex;\n            justify-content: flex-end;\n          }\n        }\n      }\n\n      .message {\n        position: absolute;\n        top: 50vh;\n        font-family: \"Chelsea Market\", sans-serif;\n        font-size: 4vmin;\n        color: yellow;\n        text-shadow: 2px 2px 1px black;\n      }\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"OrderDetail": `cPR75kdAXDGVxib0PszB`,
	"sectionHeading": `ap70fWT3eETsAtLlRQKl`,
	"orderDate": `b73kZ_AIC8CmOngOZegg`,
	"lineGameContainer": `w_xrohFcLzqrK66BLoMH`,
	"total": `V5OAbv7QFHo6WglNx0m0`,
	"button": `zypoFNoBI8rmWRRI9Gn4`,
	"totalQty": `h9JmrZXsbkyHUL5udmun`,
	"totalPrice": `qNtiRvndMCsLxZjeMJKO`,
	"span": `p73ZrVK0TdkEr6st7NOK`,
	"right": `GtULiQQdndLNSQN4Yc97`,
	"message": `NAoveQ0xvm5VtSgh6clR`
};
export default ___CSS_LOADER_EXPORT___;
